<template>
  <v-container>
    <Mapa />
    <p style="font-size: 14px; text-align:center;">Puedes ajustar la dirección.</p>
    <!-- <v-footer absolute class="font-weight-medium" padless>
      <v-btn id='confirmar_ubicacion_btn' x-large style="width: 100%; background-color:rgba(0, 0, 0, 0.12)" @click="continuar()">GUARDAR</v-btn>
    </v-footer>  -->
  </v-container>
</template>

<script>
import Mapa from "@/components/Ubicacion/Mapa.vue";
import Vista from "@/objetos/vista";

export default {
  components: {
    Mapa,
  },
  mounted() {
    Vista.nombre = "/ubicacion";
  },
  methods: {
    continuar() {
        this.$router.go(-1);     
    },
  },
};
</script>
